import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid'
import CardHeader from '@material-ui/core/CardHeader'
import Typography from '@material-ui/core/Typography'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import { sendEeProviderAlert } from 'config/helpers/integrations-lib'
import DeliveryMethodSummary from 'components/provider/DeliveryMethodSummary'
import ConfigureWebhook from 'components/provider/ConfigureWebhook'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import { NotificationManager } from 'react-notifications'
import Loader from 'components/general/Loader'
import EmailIcon from '@material-ui/icons/Email'
import CrmIcon from '@material-ui/icons/GroupAdd'

const useStyles = makeStyles(componentStyles)

function DeliveryCard(props) {
    const api = new ProviderAPI()
    const companyDetails = props.companyDetails
    const details = companyDetails.deliveryDetails || {}

    const [deliveryMethod, setDeliveryMethod] = useState(details.deliveryMethod || null)
    const [email, setEmail] = useState(details.email || '')
    const [showWebhook, setShowWebhook] = useState(false)
    const [loading, setLoading] = useState(false)

    async function saveDetails() {
        setLoading(true)
        // Capture previous state before building the new details object
        const prevDeliveryMethod = companyDetails.deliveryDetails?.deliveryMethod
        const details = {
            deliveryMethod,
            email
        }
        console.log('details: ', details)
        try {
            let company = await api.updateDeliveryDetails(companyDetails.companyId, details)
            console.log('company: ', company)
            props.updateCompany(company)
            // Fire once: only when delivery method is being set for the first time
            if (!prevDeliveryMethod && deliveryMethod) {
                sendEeProviderAlert({
                    type:           'delivery_method_selected',
                    company:        company,
                    deliveryMethod,
                    weeklyCap:      company.planDetails?.maxLeads ?? null,
                })
            }
            NotificationManager.success('Delivery method updated')
            props.onClose()
        } catch (e) {
            onError(e)
        }
        setLoading(false)
    }

    function checkRequiredFields() {
        const requiredFields = deliveryMethod === 'Email' ? [
            deliveryMethod,
            email
        ] : [deliveryMethod]
        
        // return true if any of the fields are empty
        return requiredFields.some(field => {
            // check if field is an array
            return !field
        })
    }

    function updateDeliveryMethod(method) {
        setDeliveryMethod(method)
        setShowWebhook(false)
    }

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Box component={Typography} variant='h3'>
                            Update Lead Delivery Method
                        </Box>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Typography variant="body2">
                            Select how you would like to receive leads. Email delivery setup is instant. If you select webhook a member of our team will reach out to help set this up.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} style={{ width: '100%' }}>
                        <DeliveryMethodSummary 
                            title='Email'
                            icon={<EmailIcon style={{ height: 30, width: 30, color: '#229626' }} />}
                            selectedMethod={deliveryMethod}
                            onClick={() => updateDeliveryMethod('Email')}
                            active={deliveryMethod === 'Email'}
                            //subtext='Basic'
                            disabled={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} style={{ marginBottom: '2rem' }}>
                        <DeliveryMethodSummary 
                            title='CRM'
                            icon={<CrmIcon style={{ height: 30, width: 30, color: '#229626' }} />}
                            selectedMethod={deliveryMethod}
                            onClick={() => updateDeliveryMethod('CRM')}
                            active={deliveryMethod === 'CRM'}
                            //subtext='Recommended (Premium Only)'
                            disabled={false}
                        />
                    </Grid>
                    {deliveryMethod === 'Email' &&
                        <Grid item xs={12} style={{ marginBottom: '2rem' }}>
                            <Typography variant='body2' style={{ marginBottom: '1rem' }}>
                                Please enter the email address you would like your leads delivered to, we'll send your leads directly to this email.
                            </Typography>
                            <FormGroup>
                                <FormLabel>Email</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='50%'
                                >
                                    <OutlinedInput
                                        autoComplete='off'
                                        type='text'
                                        placeholder='john.smith@gmail.com'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                    }
                    {(!showWebhook && deliveryMethod === 'CRM') &&
                        <Grid item xs={12} style={{ marginBottom: '2rem' }}>
                            <Box display='flex' flexDirection='column' alignItems='flex-start'>
                                <Typography variant='body2' style={{ marginBottom: '1rem' }}>
                                    We'll deliver leads directly to your CRM via webhook. If you select this option a member of our team will reach out to help set this up.
                                </Typography>
                                {/* <Box display='flex'>
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        onClick={() => setShowWebhook(true)}
                                        style={{marginRight: '1rem'}}
                                    >
                                        Configure Webhook
                                    </Button>
                                </Box> */}
                            </Box>
                        </Grid>
                    }

                    {showWebhook &&
                        <Grid item xs={12}>
                            <ConfigureWebhook 
                                company={companyDetails}
                            />
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='flex-end' width='100%'>
                            <Button
                                variant='contained'
                                color='primary'
                                disabled={checkRequiredFields() || loading}
                                onClick={() => saveDetails()}
                            >
                                {!loading ? (
                                    <>Submit</>
                                ) : (
                                    <Loader height={12} />
                                )}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default DeliveryCard